var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("loading")
        : !_vm.isLoading && !_vm.datacollection
        ? _c("p", [_vm._v("No hay notas registradas.")])
        : !_vm.isLoading && _vm.datacollection
        ? _c("bar-chart", {
            attrs: {
              "chart-data": _vm.datacollection,
              options: _vm.chartOptions,
              styles: _vm.styles
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }